import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { User } from 'src/app/models/users.model';
import { SharedService } from 'src/app/shared/services/shared.service';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { AddPromotionComponent } from 'src/app/shared/ui/add-promotion/add-promotion.component';
const firestore = firebase.firestore;

@Component({
  selector: 'app-profile-main',
  templateUrl: './profile-main.component.html',
})
export class ProfileMainComponent implements OnInit {
  user: User = {} as User;

  profileForm: {
    email: string;
    password: string;
    mobile: string;
    name: string;
    companyName: string;
  } = {} as any;

  loading = false;

  constructor(
    private toastr: NbToastrService,
    private ss: SharedService,
    private dialogService: NbDialogService,
    private router: Router,
    private auth: AngularFireAuth,
  ) {}

  async ngOnInit() {
    this.user = await this.ss.getUser();
    this.profileForm = {
      email: this.user.email,
      password: '',
      mobile: this.user.mobile,
      name: this.user.name,
      companyName: this.user.companyName,
    };
    const hasAddPromotion = this.router.url.includes('add-promotion');
    if (hasAddPromotion) {
      setTimeout(() => {
        this.openPromotionModal();
      }, 400);
    }
  }

  async onSubmit() {
    this.loading = true;

    try {
      if (this.user.email !== this.profileForm.email) {
        await this.updateAuthEmail(this.profileForm.email, this.profileForm.password);
      }

      await this.updateUser();
      this.toastr.success('Updated your profile', 'Success');
    } catch (error) {
      this.toastr.warning('', error.message);
      console.error(error);
    }
    this.loading = false;
  }

  private async updateUser() {
    try {
      const update: Partial<User> = {
        email: this.profileForm.email,
        mobile: this.profileForm.mobile,
        name: this.profileForm.name,
        companyName: this.profileForm.companyName,
      };

      await firestore().doc(`users/${this.user.uid}`).update(update);

      this.user = { ...this.user, ...update };
    } catch (error) {
      throw new Error('Failed to update your details. Please contact support');
    }
  }

  async updateAuthEmail(newEmail, password) {
    try {
      const currentEmail = (await this.auth.currentUser).email;
      const userCredentials = await this.auth.signInWithEmailAndPassword(currentEmail, password);
      await userCredentials.user.updateEmail(newEmail);
    } catch (error) {
      console.error(error);
      if (error.code === 'auth/email-already-in-use') {
        throw new Error('This email is already in use');
      }
      throw new Error('Failed to re-authenticate. Please check your password is correct');
    }
  }

  openPromotionModal() {
    this.dialogService.open(AddPromotionComponent, {
      context: {
        user: this.user,
      },
    });
  }
}
